export const getChangedFields = <T extends Record<string, any>>(
  currentValues: T,
  originalValues: T
): Partial<T> => {
  return Object.keys(currentValues).reduce((acc, key) => {
    const typedKey = key as keyof T;
    if (currentValues[typedKey] !== originalValues[typedKey]) {
      acc[typedKey] = currentValues[typedKey];
    }
    return acc;
  }, {} as Partial<T>);
};
